import { Button as MaterialButton, ButtonProps } from '@material-ui/core';

export const Button = (props: ButtonProps) => {
    return (
        <MaterialButton variant="contained" color="primary" {...props} />
    );
}